import axios from 'axios';
import React, { FC, useState } from 'react';

import { Twitter, Facebook, Clip, ShareApi } from '../../../../../components/ShareButton';


type Props = Spot;


type CheckBoxProps = {
    id: string;
    checked: boolean;
    label: string;
    readOnly?: boolean;
};


const CheckBox: FC<CheckBoxProps> = ({ id, checked, label, readOnly }) => {
    return (
        <>
            <input id={id} checked={checked} readOnly={readOnly} type="checkbox" /><label htmlFor={id}>{label}</label>

            <style jsx>{`
                input[type="checkbox"] {
                    display: none;
                }
                input[type="checkbox"]+label {
                    display: none;
                    cursor: pointer;
                    display: inline-block;
                    position: relative;
                    padding-left: 25px;
                    padding-right: 10px;
                    font-size: 16px;
                    font-weight: bold;
                }
                input[type="checkbox"]+label::before {
                    content: "";
                    position: absolute;
                    display: block;
                    box-sizing: border-box;
                    width: 14px;
                    height: 14px;
                    margin-top: -10px;
                    left: 0;
                    top: 50%;
                    border: 1px solid;
                    border-color:  #585753;
                    background-color: #FFF;
                }
                input[type="checkbox"]:checked+label::after {
                    content: "";
                    position: absolute;
                    display: block;
                    box-sizing: border-box;
                    width: 12px;
                    height: 6px;
                    margin-top: -9px;
                    top: 50%;
                    left: 3px;
                    transform: rotate(-45deg);
                    border-bottom: 3px solid;
                    border-left: 3px solid;
                    border-color:  #585753;
                }
                @media screen and (max-width: 540px) {
                    input[type="checkbox"]+label {
                        font-size: 14px;
                    }
                }
            `}</style>
        </>
    );
};

export const Details: FC<Props> = (props) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [loading, setLoading] = useState(false);
    const url = window.location.href;
    const title = `「${props.name}」のお店詳細はこちら`;
    const ua = navigator.userAgent.toLowerCase();
    const isMobile = (/iphone|ipad|ipod|android|mobile/.test(ua)) ||
        (/machintosh/.test(ua) && 'ontouchend' in document);
    const isApp = ua.includes('salon.jp');
    const shouldSwitchShareBtn = isMobile || isApp;

    function openLocationMapTab() {
        const unselectedTab = document.querySelector('.tab:nth-child(3)');
        // @ts-ignore
        unselectedTab.click();
        window.scrollTo(0, -1000);
    }

    function linkify(text: string) {
        const urlPattern = /https?:\/\/[\w!\?/\+\-_~=;\.\*&@#\$%\(\)'\[\]]+/g;
        const urls = text.match(urlPattern);
        if (!urls) return text;
        let result = text;
        Array.from(new Set(urls)).forEach((url) => {
            const linkify = `<a href="${url}" style="color: #ff9240; text-decoration: none; display: inline;" target="_blank">${url}</a>`;
            result = result.replaceAll(url, linkify);
        });
        return result;
    };

    async function applyAsStaff() {
        if (loading) return;
        try {
            setLoading(true);
            const { data: { success, redirect } } = await axios.post(`${window.location.origin}/api/map/spots/${props.id}/staff/apply`);
            setIsModalOpen(false);
            if (success) {
                window.location.reload();
            } else {
                window.location.href = redirect ?? '/map';
            };
        } catch {
            setIsModalOpen(false);
            window.alert('スタッフ権限の申請に失敗しました。');
        } finally {
            setLoading(false);
        };
    };

    async function cancelApplication() {
        if (loading) return;
        try {
            setLoading(true);
            const { data: { success, redirect } } = await axios.post(`${window.location.origin}/api/map/spots/${props.id}/staff/apply/cancel`);
            if (success) {
                window.location.reload();
            } else {
                window.location.href = redirect ?? '/map';
            };
        } catch (e) {
            window.alert('申請の取り消しができませんでした。');
        } finally {
            setLoading(false);
        };
    };

    return (
        <>
            <div className="cover-image">
                {props.staffs.length === 1 && (props.public ? (
                    <a
                        className="owner"
                        href={`${window.location.origin}/members/view/${props.staffs[0].shortId ?? ""}`}
                    >
                        <img
                            className="profile-image"
                            width="80"
                            height="80"
                            style={{ borderRadius: "50%" }}
                            src={props.staffs[0].facebookId ? `/user_icons/get/dummy?user_id=${props.staffs[0].userId}` : `${props.staffs[0].icon_path}`}
                        />
                    </a>
                ) : (
                    <div className="owner">
                        <img
                            className="profile-image"
                            width="80"
                            height="80"
                            style={{ borderRadius: "50%" }}
                            src={props.staffs[0].facebookId ? `/user_icons/get/dummy?user_id=${props.staffs[0].userId}` : `${props.staffs[0].icon_path}`}
                        />
                    </div>
                ))}
            </div>
            {props.staffs.length === 1 && (
                <div className="owner-name">
                    <h2>{props.staffs[0].name}</h2>
                </div>
            )}
            {props.staffs.length > 1 && (
                <div className="staff-list">
                    {props.staffs.filter((staff) => staff.role === "管理者").map((staff) => staff.public
                        ? (
                            <a className="staff" href={`${window.location.origin}/members/view/${staff.shortId ?? ""}`}>
                                <div className="owner-mark">
                                    <img src="/img/spot-owner.png" />
                                </div>
                                <img
                                    className="staff-image"
                                    width="90"
                                    height="90"
                                    src={staff.facebookId ? `/user_icons/get/dummy?user_id=${staff.userId}` : `${staff.icon_path}`}
                                />
                                <span className="staff-name">{staff.name}</span>
                            </a>
                        )
                        : (
                            <div className="staff">
                                <div className="owner-mark">
                                    <img src="/img/spot-owner.png" />
                                </div>
                                <img
                                    className="staff-image"
                                    width="90"
                                    height="90"
                                    src={staff.facebookId ? `/user_icons/get/dummy?user_id=${staff.userId}` : `${staff.icon_path}`}
                                />
                                <span className="staff-name">{staff.name}</span>
                            </div>
                        )
                    )}
                    {props.staffs.filter((staff) => staff.role === "スタッフ").map((staff) => staff.public
                        ? (
                            <a className="staff" href={`${window.location.origin}/members/view/${staff.shortId ?? ""}`}>
                                <img
                                    className="staff-image"
                                    width="90"
                                    height="90"
                                    src={staff.facebookId ? `/user_icons/get/dummy?user_id=${staff.userId}` : `${staff.icon_path}`}
                                />
                                <span className="staff-name">{staff.name}</span>
                            </a>
                        )
                        : (
                            <div className="staff">
                                {staff.role === "管理者" && (
                                    <div className="owner-mark">
                                        <img src="/img/spot-owner.png" />
                                    </div>
                                )}
                                <img
                                    className="staff-image"
                                    width="90"
                                    height="90"
                                    src={staff.facebookId ? `/user_icons/get/dummy?user_id=${staff.userId}` : `${staff.icon_path}`}
                                />
                                <span className="staff-name">{staff.name}</span>
                            </div>
                        )
                    )}
                </div>
            )}
            {props.editable && (
                <div className="admin-actions">
                    <a className="link" href={`/map/spot/${props.id}/admin`}>
                        お店管理画面
                    </a>
                </div>
            )}
            <div className="title">
                <div>
                    <p className="genre">{props.genre}</p>
                    <h1>{props.name}</h1>
                </div>
            </div>
            <div className="informations">
                <div className="item-container">
                    <div className="item">
                        <p dangerouslySetInnerHTML={{ __html: linkify(props.description) }}></p>
                        {props.delivery && (
                            <div className="option">
                                <CheckBox id="delivery" label="デリバリーが可能" checked={props.delivery} readOnly />
                            </div>
                        )}
                        {props.takeout && (
                            <div className="option">
                                <CheckBox id="takeout" label="テイクアウトが可能" checked={props.takeout} readOnly />
                            </div>
                        )}
                        {props.lunch && (
                            <div className="option">
                                <CheckBox id="lunch" label="ランチ営業あり" checked={props.lunch} readOnly />
                            </div>
                        )}
                        {props.dinner && (
                            <div className="option">
                                <CheckBox id="dinner" label="ディナー営業あり" checked={props.dinner} readOnly />
                            </div>
                        )}
                        {props.alcohol && (
                            <div className="option">
                                <CheckBox id="alcohol" label="アルコールを飲める" checked={props.alcohol} readOnly />
                            </div>
                        )}
                        {props.cafe && (
                            <div className="option">
                                <CheckBox id="cafe" label="カフェ利用が可能" checked={props.cafe} readOnly />
                            </div>
                        )}
                        {props.chimneyCoffee && (
                            <div className="option">
                                <CheckBox id="chimney_coffee" label="CHIMNEY COFFEE取扱" checked={props.chimneyCoffee} readOnly />
                            </div>
                        )}
                        {props.powerSupply && (
                            <div className="option">
                                <CheckBox id="power_supply" label="電源利用が可能" checked={props.powerSupply} readOnly />
                            </div>
                        )}
                    </div>
                </div>
                <div className="item-container">
                    <div className="label">営業時間</div>
                    <div className="item">
                        <p>{props.openingHours}</p>
                    </div>
                </div>
                <div className="item-container">
                    <div className="label">住所</div>
                    <div className="item">
                        <div className="address-link" onClick={openLocationMapTab}>
                            <p>{`${props.pref}${props.city} ${props.address}`}</p>
                        </div>
                    </div>
                </div>
            </div>
            {props.memberBenefits ?
                <div className="item-container">
                    <div className="item benefits-contents">
                        <div className="benefits-title">
                            <img
                                className="badge"
                                src="/img/pin-frag.png"
                            />
                            <h2>サロンメンバー特典</h2>
                        </div>
                        <p dangerouslySetInnerHTML={{ __html: linkify(props.memberBenefits) }}></p>
                    </div>
                </div>
                : null}
            <div className="share">
                <div className="label">URLを共有</div>
                <div className="share-buttons-container">
                    {shouldSwitchShareBtn ? <>
                        <div className="share-button">
                            <ShareApi size={62} />
                            <span style={{ marginTop: "6px" }} className="tooltip">Share</span>
                        </div>
                    </> : <>
                        <div className="share-button">
                            <Twitter size={62} title={title} url={url} />
                            <span className="tooltip">Twitter</span>
                        </div>
                        <div className="share-button">
                            <Facebook size={62} title={title} url={url} />
                            <span className="tooltip">Facebook</span>
                        </div>
                        <div className="share-button">
                            <Clip size={62} url={url} />
                            <span style={{ marginTop: "6px" }} className="tooltip">URLをコピー</span>
                        </div>
                    </>}
                </div>
            </div>
            {props.role === null && (
                <button className="request-permission-button" onClick={() => setIsModalOpen(true)}>
                    このお店のスタッフですか？
                </button>
            )}
            {props.role === "申請中" && (
                <div className="requested">
                    <div className="requested-title">
                        <h2>スタッフ権限を申請中</h2>
                        <button onClick={cancelApplication}>
                            申請を取り消す
                        </button>
                    </div>
                    <span className="requested-message">{new Date(props.requestedDate!).getFullYear()}年{new Date(props.requestedDate!).getMonth() + 1}月{new Date(props.requestedDate!).getDate()}日に申請済み</span>
                </div>
            )}
            {isModalOpen && (
                <div className="modal-mask" onClick={() => setIsModalOpen(false)}>
                    <div className="modal" onClick={(e) => e.stopPropagation()}>
                        <p>{props.name}のスタッフ権限を申請しますか？</p>
                        <div className="modal-actions">
                            <button className="cancel-button" onClick={() => setIsModalOpen(false)}>いいえ</button>
                            <button className="submit-button" onClick={applyAsStaff}>はい</button>
                        </div>
                    </div>
                </div>
            )}

            <style jsx>{`
                .cover-image {
                    position: relative;
                    width: 100%;
                    padding-top: 40%;
                    background-image: url(${props.coverImage});
                    background-position: center center;
                    background-size: cover;
                    background-repeat: no-repeat;
                    margin-bottom: 20px;
                }
                .owner {
                    position: absolute;
                    left: 50%;
                    margin: auto;
                    transform: translate(-50%, -50%);
                }
                .owner-name {
                    cursor: ${props.public ? "pointer" : "default"};
                    margin-top: 50px;
                    margin-bottom: 20px;
                }
                .owner-name > h2 {
                    font-size: 20px;
                    text-align: center;
                }
                .staff-list {
                    display: flex;
                    justify-content: space-around;
                    flex-wrap: wrap;
                    align-items: center;
                    margin-bottom: 20px;
                }
                .staff {
                    width: 90px;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                    margin-bottom: 10px;
                    position: relative;
                    text-decoration: none;
                }
                .owner-mark {
                    position: absolute;
                    top: 5px;
                    left: 5px;
                }
                .owner-mark > img {
                    width: 25px;
                    height: 25px;
                }
                .staff-image {
                    width: 90px;
                    height: 90px;
                    border-radius: 50%;
                    margin-bottom: 8px;
                }
                .staff-name {
                    width: 90px;
                    font-size: 16px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    color: rgb(253, 134, 44);
                }
                .title {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    margin-bottom: 24px;
                }
                .genre {
                    font-size: 14px;
                    margin: 0;
                }
                h1 {
                    font-weight: normal;
                    font-size: 24px;
                    margin: 0;
                }
                .edit-button {
                    cursor: pointer;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 36px;
                    height: 36px;
                    margin-top: 12px;
                    padding: 0;
                    border: solid 1px #ff6e01;
                    background: #fff;
                    border-radius: 50%;
                }
                .edit-button > img {
                    width: 18px;
                    height: 18px;
                }
                input[type=checkbox] {
                    margin-left: 0;
                }
                label {
                    font-weight: bold;
                    font-size: 16px;
                }
                .profile-image {
                    cursor: ${props.public ? "pointer" : "default"};
                    width: 100px;
                    height: 100px
                }
                .label {
                    display: flex;
                    align-items: center;
                    border-left: solid 3px black;
                    padding-left: 10px;
                    height: 24px;
                    margin-bottom: 8px;
                    font-size: 18px;
                    font-weight: bold;
                }
                .item-container {
                    margin-bottom: 66px;
                }
                .item > p,
                .item > * > p {
                    font-size: 16px;
                    margin: 0;
                    margin-bottom: 16px;
                    overflow-wrap: anywhere;
                }
                .address-link {
                    color: #ff9240;
                    text-decoration: none;
                    font-size: 16px;
                    cursor: pointer;
                }
                .benefits-contents {
                    background-image: linear-gradient(to right, #000, #000 3px, transparent 3px, transparent 8px),
                    linear-gradient(to right, #000, #000 3px, transparent 3px, transparent 8px),
                    linear-gradient(to bottom, #000, #000 3px, transparent 3px, transparent 8px),
                    linear-gradient(to bottom, #000, #000 3px, transparent 3px, transparent 8px);
                    background-size: 8px 1px, 8px 1px, 1px 8px, 1px 8px;
                    background-position: left top, left bottom, left top, right top;
                    background-repeat: repeat-x, repeat-x, repeat-y, repeat-y;
                    padding: 30px 26px 30px 26px;
                }
                .benefits-title {
                    display: flex;
                    align-items: center;
                }
                .benefits-title > h2 {
                    margin: 0;
                    margin-left: 8px;
                    font-size: 20px;
                }
                .benefits-contents > p {
                    margin: 0;
                    padding-top: 20px;
                    padding-left: 4px;
                    padding-right: 4px;
                    overflow-wrap: anywhere;
                }
                .badge {
                    width: 50px;
                    height: 50px;
                }
                .share {
                    margin-bottom: 28px;
                }
                .share-buttons-container {
                    display: flex;
                    width: 80%;
                }
                .share-button {
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                    margin-right: 18px;
                }
                .tooltip {
                    font-size: 12px;
                }
                .delete-button {
                    width: 120px;
                    height: 40px;
                    border: none;
                    color: #fff;
                    border-radius: 24px;
                    outline: none;
                    background-color: gray;
                }
                .admin-actions {
                    display: flex;
                    justify-content: center;
                }
                .admin-actions > .link {
                    position: relative;
                    padding: 0.5rem 2rem;
                    border-radius: 100vh;
                    background: #fd862c;
                    color: #ffffff;
                    font-size: 0.8rem;
                    text-decoration: none;
                    line-height: 1;
                    cursor: pointer;
                }
                .admin-actions > .link::after {
                    content: "";
                    display: block;
                    position: absolute;
                    top: 50%;
                    right: 1rem;
                    transform: translate(0, -50%);
                    border-style: solid;
                    border-color: #fd862c #fd862c #fd862c #ffffff;
                    border-width: 3px 0 3px 6px;
                }
                .request-permission-button {
                    background: none;
                    border: none;
                    color: rgb(253, 134, 44);
                    text-decoration: underline;
                    margin-bottom: 16px;
                    font-size: 16px;
                    text-align: center;
                    width: 100%;
                }
                .modal-mask {
                    position: fixed;
                    top: 0;
                    right: 0;
                    width: 100vw;
                    height: 100vh;
                    background: rgba(0, 0, 0, 0.5);
                    z-index: 10;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                }
                .modal-mask > .modal {
                    border-radius: 20px;
                    min-width: 300px;
                    max-width: 80%;
                    height: 200px;
                    background: #fff;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    flex-direction: column;
                    padding: 16px;
                }
                .modal > p {
                    margin-bottom: 30px;
                }
                .modal-actions {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    padding: 0 20px 0 20px;
                    width: 100%;
                }
                .modal-actions > .cancel-button {
                    background: none;
                    border: none;
                    color: #bbb;
                    width: 50%;
                }
                .modal-actions > .submit-button {
                    border: none;
                    background: rgb(253, 134, 44);
                    padding: 3px 15px 3px 15px;
                    color: #fff;
                    border-radius: 4px;
                    width: 50%;
                }
                .requested {
                    padding: 30px 16px 30px 16px;
                    border: 1px solid rgb(253, 134, 44);
                    border-radius: 8px;
                }
                .requested-title {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    margin-bottom: 5px;
                }
                .requested-title > h2 {
                    font-size: 16px;
                    margin: 0;
                }
                .requested-title > button {
                    border: 2px solid black;
                    padding: 8px 20px 8px 20px;
                    font-size: 12px;
                    border-radius: 4px;
                    background: #fff;
                    cursor: pointer;
                }
                .requested-message {
                    font-size: 14px;
                }
                @media screen and (max-width: 540px) {
                    .genre {
                        font-size: 12px;
                    }
                    h1 {
                        font-size: 20px;
                    }
                    label {
                        font-size: 14px;
                    }
                    .label {
                        padding-left: 10px;
                        height: 20px;
                        margin-bottom: 8px;
                        font-size: 14px;
                    }
                    .share-button {
                        margin-right: 14px;
                    }
                    .qr {
                        justify-content: center;
                        margin: 0;
                    }
                    .item-container {
                        margin-bottom: 36px;
                    }
                    .item > p {
                        font-size: 14px;
                        margin: 0;
                        margin-bottom: 14px;
                    }
                    .address-link {
                        font-size: 14px;
                    }
                    .benefits-title > h2 {
                        margin: 0;
                        margin-left: 6px;
                        font-size: 16px;
                    }
                    .benefits-contents {
                        padding: 24px 18px 26px 18px;
                    }
                    .benefits-contents > p {
                        margin: 0;
                        padding-top: 12px;
                        padding-left: 2px;
                        padding-right: 2px;
                    }
                    .badge {
                        width: 42px;
                        height: 42px;
                    }
                    .requested-title > button {
                        padding: 5px 12px 5px 12px;
                        font-size: 10px;
                    }
                }
            `}</style>
        </>
    );
};
